import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7240dbaf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-wrap col-12" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "اگر کاربر شما", -1))
const _hoisted_3 = { class: "d-flex mb-3" }
const _hoisted_4 = { class: "form-check form-check-custom form-check-solid form-check-sm border border-dashed border-light py-2 px-2 rounded" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-check-label" }, "دایرکت", -1))
const _hoisted_6 = { class: "form-check form-check-custom form-check-solid form-check-sm border border-dashed border-light py-2 px-2 rounded" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-check-label" }, "کامنت (پست و لایو)", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "کلمه یا جمله‌ای", -1))
const _hoisted_9 = { class: "mb-3" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pe-4" }, "با", -1))
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "را ارسال کند پیام زیر برایش ارسال شود", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-circle" }, null, -1))
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" ایجاد پیام ")
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = { class: "mt-5" }
const _hoisted_17 = { class: "form-check form-check-custom form-check-solid form-check-sm border border-dashed border-light py-2 px-2 rounded w-100" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-check-label" }, "فعال‌سازی برای یک پست خاص", -1))
const _hoisted_19 = { key: 0 }
const _hoisted_20 = {
  key: 0,
  class: "text-gray-600 fs-7 me-5"
}
const _hoisted_21 = { class: "d-flex flex-wrap" }
const _hoisted_22 = { class: "border border-gray rounded p-1" }
const _hoisted_23 = { class: "fs-7 mt-3 text-truncate custom-truncate h-30px" }
const _hoisted_24 = { class: "d-flex justify-content-center" }
const _hoisted_25 = ["disabled"]
const _hoisted_26 = { class: "form-check form-check-custom form-check-solid form-check-sm border border-dashed border-light py-2 px-2 rounded w-100" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-check-label" }, "ارسال کامنت بعد از ارسال دایرکت", -1))
const _hoisted_29 = {
  key: 1,
  class: "pe-5"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "fs-8 text-gray-600" }, "بعد از ارسال پیام در دایرکت، برای کامنت یک پاسخ به صورت تصادفی از بین پاسخ هایی که وارد می‌کنید کامنت و اسم کاربر در ابتدای متن اضافه می‌شود.", -1))
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "col-12 col-lg-4 col-xl-4 col-xxl-3 ps-5 d-flex justify-content-center" }
const _hoisted_33 = { id: "mobile" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "mic" }, null, -1))
const _hoisted_35 = {
  id: "pv",
  class: ""
}
const _hoisted_36 = /*#__PURE__*/_createStaticVNode("<div id=\"head\" data-v-7240dbaf><i class=\"bi bi-three-dots-vertical\" data-v-7240dbaf></i><div class=\"d-flex align-items-center\" data-v-7240dbaf><span data-v-7240dbaf>مخاطب شما</span><img class=\"mx-3\" src=\"/media/avatars/blank.png\" alt=\"\" id=\"avatar\" data-v-7240dbaf><i class=\"bi bi-arrow-left-short fs-1 mt-2\" data-v-7240dbaf></i></div></div>", 1)
const _hoisted_37 = { id: "body" }
const _hoisted_38 = {
  key: 1,
  id: "msg",
  class: "d-flex flex-column text-gray-600 fs-8 lh-lg mb-3"
}
const _hoisted_39 = {
  key: 0,
  class: "bi bi-file-earmark-arrow-down-fill mx-5",
  style: {"font-size":"2.5rem"}
}
const _hoisted_40 = {
  key: 1,
  class: "d-flex justify-content-end"
}
const _hoisted_41 = /*#__PURE__*/_createStaticVNode("<i class=\"bi bi-soundwave fs-1\" data-v-7240dbaf></i><i class=\"bi bi-soundwave fs-1\" data-v-7240dbaf></i><i class=\"bi bi-soundwave fs-1\" data-v-7240dbaf></i><i class=\"bi bi-soundwave fs-1\" data-v-7240dbaf></i><i class=\"bi bi-play-circle-fill fs-1\" data-v-7240dbaf></i>", 5)
const _hoisted_46 = [
  _hoisted_41
]
const _hoisted_47 = /*#__PURE__*/_createStaticVNode("<div id=\"send\" data-v-7240dbaf><span class=\"d-flex align-items-center\" data-v-7240dbaf><i class=\"fs-1 bi bi-mic\" data-v-7240dbaf></i><span class=\"text-muted mx-5\" data-v-7240dbaf>پیام شما</span></span><span data-v-7240dbaf><i class=\"fs-1 bi bi-emoji-smile\" data-v-7240dbaf></i></span></div>", 1)
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "circle" }, null, -1))
const _hoisted_49 = { class: "d-flex flex-column fv-row mb-5" }
const _hoisted_50 = { class: "d-flex flex-column" }
const _hoisted_51 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_52 = ["onClick"]
const _hoisted_53 = ["onMouseenter"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_Field = _resolveComponent("Field")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_ShowFile = _resolveComponent("ShowFile")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_UploadData = _resolveComponent("UploadData")!
  const _component_Emoji = _resolveComponent("Emoji")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_card, { class: "col-12 col-lg-8 col-xl-8 col-xxl-9" }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_component_el_input, {
              modelValue: _ctx.dataForm.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dataForm.name) = $event)),
              class: "w-100 mb-4",
              placeholder: "نام پاسخگو"
            }, null, 8, ["modelValue"]),
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("label", _hoisted_4, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  class: "form-check-input",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dataForm.enable_direct) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.dataForm.enable_direct]
                ]),
                _hoisted_5
              ]),
              _createElementVNode("label", _hoisted_6, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  class: "form-check-input",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dataForm.enable_comment) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.dataForm.enable_comment]
                ]),
                _hoisted_7
              ])
            ]),
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataForm.conditions, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "border border-dashed border-hover-primary p-2 rounded",
                  key: index
                }, [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.dataForm.conditions[index].type,
                    "onUpdate:modelValue": ($event: any) => ((_ctx.dataForm.conditions[index].type) = $event),
                    placeholder: "انتخاب کنید",
                    style: {"width":"120px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        key: "1",
                        label: "برابر",
                        value: "equal"
                      }),
                      _createVNode(_component_el_option, {
                        key: "2",
                        label: "شامل",
                        value: "contains"
                      })
                    ]),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue"]),
                  _hoisted_10,
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.dataForm.conditions[index].value,
                    "onUpdate:modelValue": ($event: any) => ((_ctx.dataForm.conditions[index].value) = $event),
                    style: {"width":"200px"},
                    placeholder: "مقدار"
                  }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                  _createElementVNode("button", {
                    class: "btn btn-icon btn-custom btn-light border m-1 w-25px h-25px",
                    type: "button",
                    onClick: ($event: any) => (index === 0 ? _ctx.addNewCondition() : _ctx.removeCondition(index))
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["fs-3 bi", 
                            index === 0
                              ? 'btn-light-primary bi-plus-lg'
                              : 'btn-light-danger bi-trash'
                          ])
                    }, null, 2)
                  ], 8, _hoisted_11)
                ]))
              }), 128))
            ]),
            _hoisted_12,
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                class: "btn btn-outline btn-outline-primary position-relative ml-5",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.create_msg = true))
              }, _hoisted_15)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("label", _hoisted_17, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  class: "form-check-input",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dataForm.only_for_specific_posts) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.dataForm.only_for_specific_posts]
                ]),
                _hoisted_18
              ]),
              (_ctx.dataForm.only_for_specific_posts)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    (_ctx.postLoading)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_20, "درحال دریافت پست های شما ..."))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_21, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.posts, (post) => {
                        return (_openBlock(), _createElementBlock("label", {
                          key: post.id,
                          class: "col-12 col-md-4 col-xxl-3 p-2"
                        }, [
                          _createElementVNode("div", _hoisted_22, [
                            _createVNode(_component_el_image, {
                              style: {"width":"100%","height":"150px"},
                              src: post.mediaUrl,
                              fit: "cover"
                            }, null, 8, ["src"]),
                            _createElementVNode("div", _hoisted_23, _toDisplayString(post.caption), 1),
                            _createVNode(_component_Field, {
                              class: "form-check-input mt-2",
                              type: "checkbox",
                              name: "selected_crawler",
                              value: post.instagramPostId,
                              modelValue: _ctx.dataForm.specific_posts,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dataForm.specific_posts) = $event))
                            }, null, 8, ["value", "modelValue"])
                          ])
                        ]))
                      }), 128))
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      (_ctx.instaData?.is_last_page === false)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            disabled: _ctx.postLoading,
                            class: "btn btn-outline btn-outline-primary mt-5 mb-10",
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.getPosts(_ctx.instaData.after)))
                          }, "مشاهده بیشتر", 8, _hoisted_25))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("label", _hoisted_26, [
                _withDirectives(_createElementVNode("input", {
                  disabled: !_ctx.dataForm.enable_comment,
                  type: "checkbox",
                  class: "form-check-input",
                  value: "direct",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.dataForm.send_reply_in_comment) = $event))
                }, null, 8, _hoisted_27), [
                  [_vModelCheckbox, _ctx.dataForm.send_reply_in_comment]
                ]),
                _hoisted_28
              ]),
              (_ctx.dataForm.send_reply_in_comment)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    _hoisted_30,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataForm.comments_replies, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "border border-dashed border-hover-primary p-2 rounded",
                        key: index
                      }, [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.dataForm.comments_replies[index],
                          "onUpdate:modelValue": ($event: any) => ((_ctx.dataForm.comments_replies[index]) = $event),
                          style: {"width":"200px"},
                          placeholder: "مقدار"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                        _createElementVNode("button", {
                          class: "btn btn-icon btn-custom btn-light border m-1 w-25px h-25px",
                          type: "button",
                          onClick: ($event: any) => (index === 0 ? _ctx.addNewReplies() : _ctx.removeReplies(index))
                        }, [
                          _createElementVNode("i", {
                            class: _normalizeClass(["fs-3 bi", 
                            index === 0
                              ? 'btn-light-primary bi-plus-lg'
                              : 'btn-light-danger bi-trash'
                          ])
                          }, null, 2)
                        ], 8, _hoisted_31)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("button", {
              class: "btn btn-primary position-relative me-5 mt-10",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.save()))
            }, "ایجاد")
          ])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_32, [
        _createElementVNode("div", _hoisted_33, [
          _hoisted_34,
          _createElementVNode("div", _hoisted_35, [
            _hoisted_36,
            _createElementVNode("div", _hoisted_37, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataForm.messages, (message, ib) => {
                return (_openBlock(), _createElementBlock("div", { key: ib }, [
                  (
                          message.type === 'image' ||
                          message.type === 'video'
                        )
                    ? (_openBlock(), _createBlock(_component_ShowFile, {
                        key: 0,
                        fileName: message.fileUrl,
                        file: ""
                      }, null, 8, ["fileName"]))
                    : _createCommentVNode("", true),
                  (
                        message.text !== '' 
                      )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                        _createTextVNode(_toDisplayString(message.text?.replaceAll( '<br />' ,
                      '\n')?.replaceAll( '<br />' , '\n')) + " ", 1),
                        (message.type === 'file')
                          ? (_openBlock(), _createElementBlock("i", _hoisted_39))
                          : _createCommentVNode("", true),
                        (message.type === 'audio')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_40, _hoisted_46))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]),
            _hoisted_47
          ]),
          _hoisted_48
        ])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.create_msg,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.create_msg) = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_49, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataForm.messages, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "border border-dashed border-hover-primary p-2 rounded",
                key: index
              }, [
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("div", _hoisted_51, [
                    _createVNode(_component_el_tooltip, {
                      placement: "top",
                      effect: "light",
                      content: 
                        index === 0
                          ? _ctx.translate('Add new message')
                          : _ctx.translate('Delete message')
                      
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("button", {
                          class: "btn btn-icon btn-custom btn-light border m-1 w-25px h-25px",
                          type: "button",
                          onClick: ($event: any) => (index === 0 ? _ctx.addNewItems() : _ctx.removeItem(index))
                        }, [
                          _createElementVNode("i", {
                            class: _normalizeClass(["fs-3 bi", 
                            index === 0
                              ? 'btn-light-primary bi-plus-lg'
                              : 'btn-light-danger bi-trash'
                          ])
                          }, null, 2)
                        ], 8, _hoisted_52)
                      ]),
                      _: 2
                    }, 1032, ["content"])
                  ]),
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.dataForm.messages[index].name,
                    "onUpdate:modelValue": ($event: any) => ((_ctx.dataForm.messages[index].name) = $event),
                    class: "w-100 mb-4",
                    placeholder: "عنوان"
                  }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                  _createVNode(_component_el_input, {
                    class: "flex-fill",
                    modelValue: _ctx.dataForm.messages[index].text,
                    "onUpdate:modelValue": ($event: any) => ((_ctx.dataForm.messages[index].text) = $event),
                    autosize: { minRows: 2 },
                    type: "textarea",
                    placeholder: 
                      _ctx.translate(
                        'Enter the text of the message that the recipient should receive'
                      )
                    
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"]),
                  _createElementVNode("div", {
                    onMouseenter: ($event: any) => (_ctx.emojiHelper.activeIndex = index),
                    class: "mt-2 mt-md-0 d-flex flex-row align-items-baseline justify-content-end"
                  }, [
                    (_openBlock(), _createBlock(_component_UploadData, {
                      key: 
                        index + '_' + _ctx.dataForm && _ctx.dataForm.id ? _ctx.dataForm.id : 0
                      ,
                      index: index,
                      url: "upload/file",
                      type: "multiBtn",
                      title: "select file",
                      onUploadSuccess: _ctx.fileUploadedCallBack,
                      file: _ctx.dataForm.messages[index].file,
                      fileUrl: _ctx.dataForm.messages[index].fileUrl,
                      fileType: _ctx.dataForm.messages[index].type,
                      check: _ctx.dataForm.check
                    }, null, 8, ["index", "onUploadSuccess", "file", "fileUrl", "fileType", "check"])),
                    _createVNode(_component_Emoji, { onSelectedEmoji: _ctx.addEmoji }, null, 8, ["onSelectedEmoji"])
                  ], 40, _hoisted_53)
                ])
              ]))
            }), 128))
          ]),
          _createElementVNode("button", {
            class: "btn btn-primary position-relative me-5 mt-10",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.create_msg = false))
          }, "تایید")
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}